import { tsValidateArray, tsValidateMD5, tsValidateNumber, tsValidateOptionalId, tsValidateString, tsValidateValue, tsValidator_nonMandatoryString, tsValidator_valueByKey } from '@nu-art/ts-common';
import { creationStatuses } from './types.js';
import { ListOf_ReferenceTypes } from './consts.js';
import { knowledgeManagerDBGroup } from '../common.js';
const Validator_ReferenceData = {
    snomed: {
        id: tsValidateString(),
        names: tsValidateArray(tsValidateString(), false),
        icd10: tsValidator_nonMandatoryString
    },
    loinc: { id: tsValidateString(), name: tsValidator_nonMandatoryString },
    book: {
        bookId: tsValidateString(),
        path: tsValidateArray(tsValidateNumber()),
        page: tsValidateNumber(),
        paragraph: tsValidateString()
    },
    article: {
        url: tsValidateString(),
        name: tsValidateString(),
        journal: tsValidateString(),
        publicationYear: tsValidateNumber()
    },
    upToDate: { url: tsValidateString(), name: tsValidateString(), lastUpdate: tsValidateNumber() },
    icdCode: { id: tsValidateString() },
    rxCUI: { id: tsValidateString() },
    atc: { id: tsValidateString() },
    cpt: { id: tsValidateString() },
};
const Validator_ModifiableProps = {
    type: tsValidateValue(ListOf_ReferenceTypes),
    data: tsValidator_valueByKey(Validator_ReferenceData),
    creationStatus: tsValidateValue([...creationStatuses], false)
};
const Validator_GeneratedProps = {
    uid: tsValidateMD5(),
    __bookId: tsValidateOptionalId,
};
export const DBDef_Reference = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.2', '1.0.1'],
    dbKey: 'references',
    entityName: 'Reference',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'reference'
    },
    backend: {
        name: 'references'
    },
    dependencies: {
        '__bookId': {
            dbKey: 'books',
            fieldType: 'string'
        }
    }
};
//# sourceMappingURL=db-def.js.map